/**
 * Pointer tracking for the service cards (prop-for-that's `pointer-local`).
 */
( function() {
	const cards = document.querySelectorAll( '[data-pointer-local]' );

	if ( ! cards.length ) {
		return;
	}

	if ( ! window.matchMedia( '(hover: hover) and (pointer: fine)' ).matches ) {
		return;
	}

	let latest = null;
	let frame = 0;

	/**
	 * Round to the precision the CSS can actually use.
	 *
	 * @param {number} value Ratio to round.
	 * @return {string} The ratio as a custom property value.
	 */
	function ratio( value ) {
		return String( Math.round( value * 1000 ) / 1000 );
	}

	/**
	 * Write the pointer's position into every card.
	 */
	function write() {
		frame = 0;

		cards.forEach( function( card ) {
			const box = card.getBoundingClientRect();

			if ( ! box.width || ! box.height ) {
				return;
			}

			const x = ( latest.clientX - box.left ) / box.width;
			const y = ( latest.clientY - box.top ) / box.height;
			const inside = x >= 0 && x <= 1 && y >= 0 && y <= 1;

			card.style.setProperty( '--live-local-pointer-x-ratio', ratio( x ) );
			card.style.setProperty( '--live-local-pointer-y-ratio', ratio( y ) );
			card.style.setProperty( '--live-local-pointer-inside', inside ? '1' : '0' );
		} );
	}

	window.addEventListener( 'pointermove', function( event ) {
		latest = event;

		if ( ! frame ) {
			frame = window.requestAnimationFrame( write );
		}
	}, { passive: true } );
}() );
